import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryVM} from "../../models/CategoryVM.model";
import {CategoryService} from "../../services/category/category.service";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';


@Component({

  selector: 'rw-service-cards',  // <home></home>

  styles: [require('./service-cards.component.css')],

  template: require('./service-cards.component.html'),
  animations: [
    trigger('displayState', [
      state('hide', style({opacity:'0',height:'0px'})),
      state('show',   style({opacity:'1'})),
      transition('show => hide', animate('300ms ease-in',style({  transform: 'translateY(300px)'}))),
      transition('hide => show', animate('200ms ease-out' , style({transform:'translateY(300px)'})))

    ])
  ]
})
export class ServiceCardsComponent implements OnInit,OnChanges {

  @Input() public company:CompanyVM;
  @Input() public canReserveByClient:boolean;
  public categories:CategoryVM[] = [];
  public mainCat:CategoryVM;
  public categoryDisplayMode:string='show';
  public serviceDisplayMode:string='hide';
  public categoryLevel2DisplayMode='hide';

  public categoryDisplayModeFlag:boolean=true;
  public serviceDisplayModeFlag:boolean=false;
  public categoryLevel2DisplayModeFlag:boolean=false;

  public selectedCategory:any;
  public selectedCategory2:any;


  /**
   * TypeScript public modifiers
   */
  constructor(private activatedRoute:ActivatedRoute, private companyService:CompanyService, private categoryService:CategoryService) {
  }



  gotoShowServiceList()
  {
    this.setserviceDisplayModeFlag(true);
    this.categoryDisplayMode='hide';
    this.setcategoryDisplayModeFlag(false);
    this.serviceDisplayMode='show';



  }

  gotoCategoryLevel2()
  {
    this.setcategoryLevel2DisplayModeFlag(true);
    this.categoryDisplayMode='hide';
    this.setcategoryDisplayModeFlag(false);
    this.serviceDisplayMode='hide';
    this.setserviceDisplayModeFlag(false);
    this.categoryLevel2DisplayMode='show'


  }
  backShowCategoryList()
  {
    this.setcategoryDisplayModeFlag(true);
    this.categoryDisplayMode='show';

    this.serviceDisplayMode='hide';
    this.setserviceDisplayModeFlag(false);

  }
  backShowCategoryLevel2List()
  {
    this.setserviceDisplayModeFlag(true);
    this.categoryDisplayMode='hide';
    this.setcategoryDisplayModeFlag(false);
    this.serviceDisplayMode='show';

    this.categoryLevel2DisplayMode='hide';
    this.setcategoryLevel2DisplayModeFlag(false);

  }
  public imageList:ImageVM[];
  public imageUrl;


  public ngOnInit() {
    // console.log(this.canReserveByClient);
    this.getCompanyCategory();
  }

  getCompanyCategory() {
    let parent = this;
    this.companyService.getCompanyInfo().subscribe((com)=> {
      parent.company = com;
      parent.categoryService.getRootCategories(parent.company.keyUrl).subscribe(cats=> {
        parent.categories = cats;
        parent.categories.forEach((cat)=>{
        parent.setCategoryImageUrl(cat);
        })

        if (cats.length == 1)
          parent.mainCat = cats[0];
        parent.getCategoriesChilds(parent.mainCat);
        parent.getCategoryServices(parent.mainCat);
        //parent.categories.forEach((c)=> {
        //  parent.categoryService.getServiceItemsByCategoryId(c.id)
        //    .subscribe((services)=> {
        //       c.serviceList=services;
        //    });
        //});

      });
    });

  }
  setCategoryImageUrl(cat)
  {
    let parent=this;
    cat.imageUrl=parent.companyService.makeImageUrl('category',cat.coverImage,parent.company.activityType,false);
  }
  onCategoryExpanded(cat) {
    this.goToTop();
    this.getCategoryServices(cat);
    this.getCategoriesChilds(cat);
    this.selectedCategory=cat;
    this.gotoShowServiceList();
  }
  onCategoryExpandedLevel2(cat)
  {
    this.goToTop();
    this.getCategoryServices(cat);
    this.getCategoriesChilds(cat);
    this.selectedCategory2=cat;

    this.gotoCategoryLevel2();
  }
goToTop(){
  window.scroll(0,0);
}
  onCategoryCollapsed(cat) {
    this.backShowCategoryList();
  }
  onCategoryCollapsed2(cat)
  {
    this.backShowCategoryLevel2List();
  }
  onServiceExpanded(si) {
    let parent = this;
    if (si && !si.detail) {
      parent.categoryService.getServiceItemDetailById(si.id)
        .subscribe((sdetail)=> {
          si.detail = sdetail;
          parent.setDuration(si.detail);
          this.getServiceImage(si.detail);
        })
    }
  }
  public setserviceDisplayModeFlag(value:boolean)
  {
    let parent=this;

    //if(value)
    //  parent.serviceDisplayModeFlag=value;
    //else
   setTimeout(function(){
     parent.serviceDisplayModeFlag=value;
   },500);


  }
  public setcategoryDisplayModeFlag(value:boolean)
  {
    let parent=this;

    //if(value)
    //  parent.categoryDisplayModeFlag=value;
    //else
      setTimeout(function(){
        parent.categoryDisplayModeFlag=value;
      },500);


  }
  public setcategoryLevel2DisplayModeFlag(value:boolean)
  {
    let parent=this;
    //
    //if(value)
    //  parent.categoryLevel2DisplayModeFlag=value;
    //else
      setTimeout(function(){
        parent.categoryLevel2DisplayModeFlag=value;
      },500);


  }

  getCategoryServices(cat:CategoryVM) {
    let parent = this;
    if (cat && !cat.serviceList)
      parent.categoryService.getServiceItemsHeaderByCategoryId(cat.id)
        .subscribe((services)=> {
          cat.serviceList = services;
        });
  }
  getCategoriesChilds(cat:CategoryVM) {
    let parent = this;
    if (cat && !cat.serviceList)
      parent.categoryService.getCategoriesByParentId(cat.id)
        .subscribe((cats)=> {
          cat.categories = cats;
          cats.forEach((cat2)=>{
            parent.setCategoryImageUrl(cat2);
          })

        });
  }
  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;


  }
  getServiceImage(si:ServiceItemDetailVM) {
    let parent = this;
    if (si && si.imageAlbum && si.imageAlbum.imageList && si.imageAlbum.imageList.length > 0 ) {

      si.coverImage = si.imageAlbum.imageList[0];
    }
  }
  setDuration(sd) {
    if (sd.scheduleInfo && sd.scheduleInfo.weeklyScheduleInfo && sd.scheduleInfo.weeklyScheduleInfo.timePeriod) {
      sd.duration = sd.scheduleInfo.weeklyScheduleInfo.timePeriod.duration;
    }
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/service-cards/service-cards.component.ts